let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1sTS1")).then(() => parcelRequire('ev1gN'));